import { useEffect } from 'react';
import cm from 'classnames';

import { useLocation, Path } from 'components/_hooks/use-router';
import { useAppSelector, useAppDispatch } from 'store/store-hooks';
import { setConfigPanel } from 'components/app/editor/_mediator/editor.slice';

import { ConfigPanelClip } from 'components/app/editor/editor-configure/config-panel-clip';
import { ConfigPanelFile } from 'components/app/editor/editor-configure/config-panel-file';
import styles from './_app-layout.module.scss';

export const AppLayoutSide = () => {
  const { path } = useLocation();
  const configPanel = useAppSelector((state) => state.editor.configPanel);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (configPanel === null) return;
    if ((path === Path.storyboard && configPanel !== 'clip') || path === Path.finalcuts) dispatch(setConfigPanel(null));
  }, [path]);

  return (
    <div className={cm(styles.SidePanel, { [styles['SidePanel--active']]: configPanel })}>
      <div className={styles.SidePanel__content}>
        <div className={styles.SidePanel__close} onClick={() => dispatch(setConfigPanel(null))}>
          Esc
        </div>
        {configPanel && (configPanel === 'clip' ? <ConfigPanelClip /> : <ConfigPanelFile />)}
      </div>
    </div>
  );
};
